import React, { useState } from "react";
import { Button, Divider, Modal, Row, Col, Tooltip } from "antd";
import { NavLink, Link } from "react-router-dom";
import { DownOutlined, PlayCircleOutlined } from "@ant-design/icons";
import { Breakpoint } from "react-socks";
import LandingPageMobile from "./LandingPageMobile";
import RequestDemo from "./RequestDemo";
import "./landing-page.style.less";
import LandingPageHeader from "./LandingPageHeader";
import VideoModal from "../VideoPlayer/VideoModal";

const LandingPage = () => {
  const [requestDemoModalOpen, setRequestDemoModalOpen] = useState(false)
  const [isMobileView, setIsMobileView] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const solarflowPlatformFeatures = [
    {
      title: "Smart Gantt Chart monitoring every aspect of your project",
      image: require('../../assets/images/Landing-Page/Solarflow Platform Features/ic-gantt.svg'),
    },
    {
      title: "Automated report generations",
      image: require('../../assets/images/Landing-Page/Solarflow Platform Features/ic-reports.svg'),
    },
    {
      title: "Automated performance tracking",
      image: require('../../assets/images/Landing-Page/Solarflow Platform Features/ic-dashboard.svg'),
    },
    {
      title: "Standardize and customize workflows",
      image: require('../../assets/images/Landing-Page/Solarflow Platform Features/ic-no task list.svg'),
    },
    {
      title: "Automate customer updations",
      image: require('../../assets/images/Landing-Page/Solarflow Platform Features/ic-Single user.svg'),
    },
    {
      title: "Cloud-Based secure storage & data back up",
      image: require('../../assets/images/Landing-Page/Solarflow Platform Features/ic-cloud-tech.svg'),
    },
  ]

  const scrollToElement = (element) => {
    var elementPosition;
    if (element === 'standardize-processes') {
      elementPosition = document.getElementById(element).offsetTop-70;
    }
    else if (element === "top") {
      window.scrollTo(0, 0);
    }
    else {
      elementPosition = document.getElementById(element).offsetTop-550;
    }
    window.scrollTo(0, elementPosition);
  };

  const handleRequestDemoMobile = () => {
    setIsMobileView(true);
    setRequestDemoModalOpen(true);
  };

  const handleSeeVideo = () => {
    setShowVideoModal(true);
  };

  return (
    <div className="landing-page-wrapper">
      <React.Fragment>
        <Breakpoint medium up>
        <LandingPageHeader />
          {/* <div className="main-header-wrapper">
            <div className="main-header-link-wrapper">
              <nav className="main-header-nav-wrapper">
                <ul className="main-header-list-wrapper">
                  <li className="main-header-logo">
                  <div className="main-header-logos-wrapper" onClick={() => scrollToElement("top")}>
                    <img
                      src={require("../../assets/logos/SafEarth Logo_Blue with White.png")}
                    />
                    <Divider type="vertical" />
                    <img
                      src={require("../../assets/images/Landing-Page/Solar-Flow-Nav-Logo.png")}
                      className="solar-flow-nav-logo"
                    />
                  </div>
                  </li>
                  <li className="features-li">
                    <Link
                      activeClassName="is-active"
                      onClick={() =>
                        scrollToElement("solarflow-platform-features")
                      }
                      className="features-link"
                    >
                      Features
                    </Link>
                  </li>
                  <li className="whats-more-li">
                    <Link
                      activeClassName="is-active"
                      onClick={() =>
                        scrollToElement("standardize-processes")
                      }
                      className="whats-more-link"
                    >
                      What's More
                    </Link>
                  </li>
                  <li className="login-li">
                    <NavLink activeClassName="is-active" to="/login">
                      <Button className="login-btn">Login</Button>
                    </NavLink>
                  </li>
                  <li className="signup-li">
                    <NavLink activeClassName="is-active" to="/signup">
                      <Button type="primary" className="signup-btn">Signup</Button>
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
          </div> */}

          <div className="landing-page-container">
            <div className="landing-page-section-1-wrapper">
              <div>
                <img src={require('../../assets/logos/SafEarth-Landing-Page-Logo.png')} alt="SolarFlow" className="solar-flow-landing-page-logo" />
              </div>
              <div className="landing-primary-heading-wrapper">
                  <p className="landing-primary-heading">
                    Automate, Digitise, and Standardise your Solar plant
                    Installation process
                  </p>
              </div>
              <div className="landing-secondary-heading-wrapper">
                <p className="landing-secondary-heading1">
                  A dedicated tool built for the renewable energy industry to
                  help EPC companies
                </p>
                <p className="landing-secondary-heading2"> execute projects better, faster, and more
                  easily.
                </p>
              </div>
              <div className="first-section-buttons-wrapper">
                <button className="scroll-down-btn" onClick={() => scrollToElement("solarflow-platform-features")}>
                  Scroll Down
                  <img src={require('../../assets/images/Landing-Page/Scroll down.svg')} className="scroll-down-image"/>
                </button>
                <Button className="see-how-it-works-btn" onClick={handleSeeVideo}>See how it works <PlayCircleOutlined /></Button>
                {showVideoModal && (
                  <VideoModal
                    visible={showVideoModal}
                    setVisible={setShowVideoModal}
                    videoURL="https://safearth-static.s3.ap-south-1.amazonaws.com/explainer_subbed.mp4"
                  />
                )}
              </div>
              <img src={require('../../assets/images/Landing-Page/Flow-Illustration.png')} className="flow-illustration-image"/>
            </div>

            <div className="flow-illustration-extension"></div>

            <div id="solarflow-platform-features" className="solarflow-platform-features-wrapper">
              <p className="solarflow-platform-features-header">
                SolarFlow Platform Features
              </p>
              <div className="solarflow-platform-features-container">
                <Row gutter={[16, 16]}>
                  {solarflowPlatformFeatures.map(feature =>
                    <Col span={8}>
                      <img src={feature.image} className="checkmark-image"/>
                      <p className="platform-feature-text">{feature.title}</p>
                    </Col>
                  )}
                </Row>
              </div>
            </div>

            <div id="standardize-processes" className="standardize-processes-wrapper">
              <img src={require('../../assets/images/Landing-Page/Screen 1_Detailed Event.png')} className="detailed-event-image"/>
              <p className="standardize-processes-header">
                Standardize Processes
              </p>
              <p className="standardize-processes-subtext-1">
                Customize the Platform to incorporate your standard operating procedures
              </p>
              <p className="standardize-processes-subtext-2">
                The SafEarth Platform allows any user to customize the installation process based on their own Standard Operating Procedures. Our tools ensure and monitor that all your projects are now following the same processes. 
                You can create as many different workflows as you need.
              </p>
            </div>
            
            <img src={require('../../assets/images/Landing-Page/Flow-Illustration-2.png')} className="flow-illustration-image-2"/>

            <div className="simplify-communication-wrapper">
              <p className="simplify-communication-header">
                Simplify Communication
              </p>
              <p className="simplify-communication-subtext-1">
                Bring All Stakeholders on one Platform
              </p>
              <p className="simplify-communication-subtext-2">
                The SafEarth Platform brings all stakeholders of the project, your own team, manufacturers, sub-contractors, and most importantly the Customer on one common platform. This ensures that everyone is updated about what is happening on the project and communications gets simplified without any additional efforts.
              </p>
              <img src={require('../../assets/images/Landing-Page/PSD_07.png')} className="simplify-communication-image"/>
            </div>

            <div className="automate-wrapper">
              <p className="automate-header">
                Automate Automate Automate
              </p>
              <p className="automate-subtext-1">
                Automate a number of routine activities
              </p>
              <p className="automate-subtext-2">
                The Platform allows our users to automate a number of activities thereby saving precious time and ensuring that these can happen without any errors. Generate customized reports, before, during, and after your projects. These reports can also be automatically shared with external stakeholders.
              </p>
            </div>

            <img src={require('../../assets/images/Landing-Page/Automate.png')} className="automate-image-1" />

            {/* <img src={require('../../assets/images/Landing-Page/Screen 2_Notifications.png')} className="automate-image-2"/> */}
            
            <div className="performance-tracking-wrapper">
              <img src={require('../../assets/images/Landing-Page/Performance-Tracking-background.png')} className="performance-tracking-flow-illustration"/>
              <div className="performance-tracking-header">
                Performance Tracking and Benchmarking
              </div>
              <div className="performance-tracking-subtext-1">
                Track performance of your team and process to improve them
              </div>
              <div className="performance-tracking-subtext-2">
                The SafEarth Platform captures a large amount of data and tracks the performance of various team members and subcontractors throughout the project cycle. This allows the decision-makers to make data-driven decisions and improve the performance of both the team and the process itself.
              </div>
            </div>

            <img src={require('../../assets/images/Landing-Page/Performance-Tracking-image.png')} className="performance-tracking-image" />
            
            <div className="footer-wrapper">
              <img src={require("../../assets/images/Landing-Page/App now availale.png")} className="app-now-available-image" />
              <img src={require('../../assets/images/Landing-Page/Screen 5_Documents.png')} className="holding-phone-image"/>
              <div style={{ display: 'flex', marginLeft: "27vw", marginTop: '-13rem'}}>
                <img
                  src={require("../../assets/images/Landing-Page/Google_playstore.png")}
                  className="google-play-store-icon"
                  onClick={() => window.open("https://play.google.com/store/apps/details?id=in.safearth.solarflow", "_blank")}
                />
                <img
                  src={require("../../assets/images/Landing-Page/Appstore.png")}
                  className="apple-app-store-icon"
                  onClick={() => window.open("https://apps.apple.com/us/app/solarflow-safearth/id1594860090", "_blank")}
                />
              </div>

              <div className="footer-subtext">
                Now available on Play Store & App Store
              </div>

              <div className="request-demo-wrapper">
                <Row>
                  <Col span={18}>
                    <div className="request-demo-header">
                      Join the SafEarth platform today.
                    </div>
                  </Col>
                  <Col span={6}>
                  <Button
                    type="primary"
                    onClick={() => setRequestDemoModalOpen(true)}
                    className="request-demo-btn"
                  >
                    Request a Demo
                  </Button>
                  </Col>
                </Row>
              </div>
            </div>
            <Tooltip
              color="#000"
              placement="left"
              title={
                <Button
                  style={{ background: "#000", color: "#fff", border: "none", fontSize: "18px", marginBottom: "5px", fontWeight: 300}}
                  onClick={() => setRequestDemoModalOpen(true)}
                >
                  Request a Demo
                </Button>
              }
              overlayStyle={{ boxShadow: "0 auto auto 0 rgba(0, 0, 0, 0.16)" }}
              overlayInnerStyle={{ backgroundColor: '#fff', borderRadius: "5px"}}
              trigger="click"
            >
              <Button className="request-demo-floating-btn">
                <img src={require("../../assets/images/Landing-Page/Request a demo.png")} />
              </Button>
            </Tooltip>
          </div>
        </Breakpoint>
        <Breakpoint small down>
          <LandingPageMobile requestDemoAction={() => handleRequestDemoMobile()} />
        </Breakpoint>
      </React.Fragment>
      {/* Request a Demo Modal */}
      <Modal
        className=""
        visible={requestDemoModalOpen}
        centered
        onCancel={() => setRequestDemoModalOpen(false)}
        closable={false}
        destroyOnClose
        footer={""}
        width={isMobileView ? "30rem" : "60rem"}
      >
        {requestDemoModalOpen && (
          <RequestDemo onClose={() => setRequestDemoModalOpen(false)} />
        )}
      </Modal>
    </div>
  );
};

export default LandingPage;
